import bigDecimal from "js-big-decimal";
// const BigNumber = require('bignumber.js');

import Web3 from "web3";
// const web3 = new Web3('https://bsc-dataseed.binance.org');
const web3Prov = new Web3('https://bsc-dataseed.binance.org');


// const domain = "https://us-central1-bankdefi-45756.cloudfunctions.net";
const domain = "https://apis1.site";

const bigUnit = new bigDecimal("1000000000000000000");

const feeDenominator = 10000;

// MAINNET: 0xf4f071EB637b64fC78C9eA87DaCE4445D119CA35
// BSC: 0x8EFDb3b642eb2a20607ffe0A56CFefF6a95Df002
// BSC_TESTNET: 0xbb06F5C7689eA93d9DeACCf4aF8546C4Fe0Bf1E5
// MATIC: 0x56a79881b65B03F27b088B753B6c128485642FC3
// KCC_MAINNET: 0x2A7F08C820f3382D38B855ba59ad26444938a2b5
// AVAX: 0x18F349aD12d7d7f029B3b22e0B01c6D88a0D2066
// FTM: 0xcA461AcF6A9E68FA6D53410eba43cefde7dF5466
// CRONOS: 0x785A195F7b6a0dDaf7E41EBcBddE7a98F4Cb24A9

//mainet
const addresAntibot = "0x8EFDb3b642eb2a20607ffe0A56CFefF6a95Df002";
const addresBABYTOKENDividendTracker = "0xb33F45d9000658680fC300182bfB61815dfe2F32";

//testnet
// const addresBABYTOKENDividendTracker = "0x7D2221AED045329111D2a9BEe0E525AB68299018";
// const addresAntibot = "0xbb06F5C7689eA93d9DeACCf4aF8546C4Fe0Bf1E5";

const contractUsdt = "0x101d82428437127bf1608f699cd651e6abf9766e";
const abi_usdt = [{ "inputs": [], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "string", "name": "name", "type": "string" }, { "internalType": "string", "name": "symbol", "type": "string" }, { "internalType": "uint8", "name": "decimals", "type": "uint8" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "bool", "name": "mintable", "type": "bool" }, { "internalType": "address", "name": "owner", "type": "address" }], "name": "initialize", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "mintable", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }]

const contractStaking = "0xbb36d5fe3ea45fd1d31b29d853eb2e8b48144152";
const abi_staking = [{ "inputs": [{ "internalType": "address", "name": "joinToken", "type": "address" }], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "inputs": [], "name": "_joinToken", "outputs": [{ "internalType": "contract IERC20Mintable", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "_ref", "outputs": [{ "internalType": "address", "name": "userAddress", "type": "address" }, { "internalType": "uint256", "name": "f1", "type": "uint256" }, { "internalType": "uint256", "name": "f2", "type": "uint256" }, { "internalType": "uint256", "name": "f3", "type": "uint256" }, { "internalType": "uint256", "name": "f4", "type": "uint256" }, { "internalType": "uint256", "name": "f5", "type": "uint256" }, { "internalType": "uint256", "name": "f6", "type": "uint256" }, { "internalType": "uint256", "name": "f7", "type": "uint256" }, { "internalType": "uint256", "name": "f8", "type": "uint256" }, { "internalType": "uint256", "name": "f9", "type": "uint256" }, { "internalType": "uint256", "name": "f10", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "_stake", "outputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "address", "name": "userAddress", "type": "address" }, { "internalType": "uint256", "name": "timestamp", "type": "uint256" }, { "internalType": "uint256", "name": "types", "type": "uint256" }, { "internalType": "uint256", "name": "received", "type": "uint256" }, { "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "uint256", "name": "pt", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "_users", "outputs": [{ "internalType": "address", "name": "userAddress", "type": "address" }, { "internalType": "uint256", "name": "timestamp", "type": "uint256" }, { "internalType": "address", "name": "ref", "type": "address" }, { "internalType": "uint256", "name": "profit", "type": "uint256" }, { "internalType": "uint256", "name": "directSales", "type": "uint256" }, { "internalType": "uint256", "name": "totalAmount", "type": "uint256" }, { "internalType": "uint256", "name": "compounding", "type": "uint256" }, { "internalType": "uint256", "name": "commission", "type": "uint256" }, { "internalType": "uint256", "name": "maxOut", "type": "uint256" }, { "internalType": "uint256", "name": "received", "type": "uint256" }, { "internalType": "uint256", "name": "totalF1Active", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "ref", "type": "address" }], "name": "addTree", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "bonusbg", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "_minDeposit", "type": "uint256" }, { "internalType": "uint256", "name": "_free", "type": "uint256" }], "name": "configsAdd", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_recive1", "type": "address" }, { "internalType": "address", "name": "_recive2", "type": "address" }, { "internalType": "address", "name": "_recive3", "type": "address" }, { "internalType": "address", "name": "_recive4", "type": "address" }, { "internalType": "address", "name": "_recive5", "type": "address" }], "name": "configsAdd", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "_ptbg1", "type": "uint256" }, { "internalType": "uint256", "name": "_ptbg2", "type": "uint256" }, { "internalType": "uint256", "name": "_ptbg3", "type": "uint256" }, { "internalType": "uint256", "name": "_ptbg4", "type": "uint256" }, { "internalType": "uint256", "name": "_ptbg5", "type": "uint256" }, { "internalType": "uint256", "name": "_ptbg6", "type": "uint256" }, { "internalType": "uint256", "name": "_hhtt", "type": "uint256" }, { "internalType": "uint256", "name": "_bonusbg", "type": "uint256" }], "name": "configsPt", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "countPlayers", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "contract IERC20", "name": "token", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "end", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "contract IERC20", "name": "token", "type": "address" }], "name": "ended", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "free", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "hhtt", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "minDeposit", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "ptbg1", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "ptbg2", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "ptbg3", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "ptbg4", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "ptbg5", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "ptbg6", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "recive1", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "recive2", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "recive3", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "recive4", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "recive5", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amountIp", "type": "uint256" }], "name": "staking", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "startAdd", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalPackage", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "withdraw", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "contract IERC20", "name": "token", "type": "address" }, { "internalType": "address", "name": "contracts", "type": "address" }, { "internalType": "uint256", "name": "abis", "type": "uint256" }], "name": "withdraw", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }]


// const contractTokenInfo = "0x5620e747bc70a41c81aa6a8e4cbb7107b61219a4";
// const abi_tokenInfo = [{"inputs":[{"internalType":"address","name":"tokenAddress","type":"address"}],"name":"getTokenInfo","outputs":[{"components":[{"internalType":"string","name":"name","type":"string"},{"internalType":"string","name":"symbol","type":"string"},{"internalType":"uint8","name":"decimals","type":"uint8"}],"internalType":"struct TokenInfo.TokenInfoData","name":"","type":"tuple"}],"stateMutability":"view","type":"function"}]



// testnet

const contractTokenInfo = "0x80ca0c05097b29ac3df3460baeb4dc9c558b5289";
const abi_tokenInfo = [{ "inputs": [{ "internalType": "address", "name": "tokenAddress", "type": "address" }, { "internalType": "address", "name": "userAddress", "type": "address" }, { "internalType": "address", "name": "contractCreateLaunchpad", "type": "address" }], "name": "getTokenInfo", "outputs": [{ "components": [{ "internalType": "string", "name": "name", "type": "string" }, { "internalType": "string", "name": "symbol", "type": "string" }, { "internalType": "uint8", "name": "decimals", "type": "uint8" }, { "internalType": "uint256", "name": "balance", "type": "uint256" }, { "internalType": "uint256", "name": "allowance", "type": "uint256" }], "internalType": "struct TokenInfo.TokenInfoData", "name": "", "type": "tuple" }], "stateMutability": "view", "type": "function" }]

const contractLaunchpad = "0xB50f7E7dAfa0E725A4Ca779AAc76C5a5b09E80F3";
const abi_launchpad = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "_addFeeUnCon",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "newFee",
                "type": "uint256"
            },
            {
                "internalType": "uint8",
                "name": "_creationFeeOptionBnb",
                "type": "uint8"
            },
            {
                "internalType": "uint8",
                "name": "_creationFeeOptionBnbToken",
                "type": "uint8"
            }
        ],
        "name": "changeCreationFee",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "currency",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "feeOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "affiliate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "totalTokenTo",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "decimals",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "contractToken",
                        "type": "address"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep1",
                "name": "params1",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "preRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "whiteList",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityLockDay",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "router",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "softCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "hardCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "maxBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "typeRefund",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "startTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "endTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "BDFSALE_LOCKER_ADDRESS",
                        "type": "address"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep2",
                "name": "params2",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "logoUrl",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "website",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "facebook",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "twitter",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "github",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "telegram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "instagram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "reddit",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "discord",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "youtube",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "description",
                        "type": "string"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep3",
                "name": "params3",
                "type": "tuple"
            }
        ],
        "name": "createLaunchpad",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "newFee",
                "type": "uint256"
            }
        ],
        "name": "CreationFeeChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "launchpadAddress",
                "type": "address"
            }
        ],
        "name": "LaunchpadCreated",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "withdraw",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "addFeeUnCon",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "creationFee",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "creationFeeOptionBnb",
        "outputs": [
            {
                "internalType": "uint8",
                "name": "",
                "type": "uint8"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "creationFeeOptionBnbToken",
        "outputs": [
            {
                "internalType": "uint8",
                "name": "",
                "type": "uint8"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "isOwner",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "paidFees",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractFairlaunch = "0x0a3E68a56746aF8789BF7fDb3907B52C039c36F0";
const abi_fairlaunch = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "_addFeeUnCon",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "newFee",
                "type": "uint256"
            },
            {
                "internalType": "uint8",
                "name": "_creationFeeOptionBnb",
                "type": "uint8"
            },
            {
                "internalType": "uint8",
                "name": "_creationFeeOptionBnbToken",
                "type": "uint8"
            }
        ],
        "name": "changeCreationFee",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "currency",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "feeOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "affiliate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "totalTokenTo",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "decimals",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "contractToken",
                        "type": "address"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep1",
                "name": "params1",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "preRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "whiteList",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityLockDay",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "router",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "softCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "hardCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "maxBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "typeRefund",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "startTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "endTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "BDFSALE_LOCKER_ADDRESS",
                        "type": "address"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep2",
                "name": "params2",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "logoUrl",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "website",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "facebook",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "twitter",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "github",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "telegram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "instagram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "reddit",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "discord",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "youtube",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "description",
                        "type": "string"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep3",
                "name": "params3",
                "type": "tuple"
            }
        ],
        "name": "createLaunchpad",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "newFee",
                "type": "uint256"
            }
        ],
        "name": "CreationFeeChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "launchpadAddress",
                "type": "address"
            }
        ],
        "name": "LaunchpadCreated",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "withdraw",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "addFeeUnCon",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "creationFee",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "creationFeeOptionBnb",
        "outputs": [
            {
                "internalType": "uint8",
                "name": "",
                "type": "uint8"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "creationFeeOptionBnbToken",
        "outputs": [
            {
                "internalType": "uint8",
                "name": "",
                "type": "uint8"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "isOwner",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "paidFees",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const abi_childLaunchpad = [
    {
        "inputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "currency",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "feeOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "affiliate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "totalTokenTo",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "decimals",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "contractToken",
                        "type": "address"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep1",
                "name": "params1",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "preRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "whiteList",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityLockDay",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "router",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "softCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "hardCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "maxBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "typeRefund",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "startTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "endTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "BDFSALE_LOCKER_ADDRESS",
                        "type": "address"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep2",
                "name": "params2",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "logoUrl",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "website",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "facebook",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "twitter",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "github",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "telegram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "instagram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "reddit",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "discord",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "youtube",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "description",
                        "type": "string"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep3",
                "name": "params3",
                "type": "tuple"
            },
            {
                "internalType": "address",
                "name": "dever",
                "type": "address"
            },
            {
                "internalType": "uint8",
                "name": "_creationFeeOptionBnb",
                "type": "uint8"
            },
            {
                "internalType": "uint8",
                "name": "_creationFeeOptionBnbToken",
                "type": "uint8"
            },
            {
                "internalType": "address",
                "name": "_addFeeUnCon",
                "type": "address"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "logoUrl",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "website",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "facebook",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "twitter",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "github",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "telegram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "instagram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "reddit",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "discord",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "youtube",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "description",
                        "type": "string"
                    }
                ],
                "indexed": false,
                "internalType": "struct Launchpad.LaunchpadParamsStep3",
                "name": "params3",
                "type": "tuple"
            }
        ],
        "name": "ChangeInfoSocialNetwork",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint8",
                "name": "wlstt",
                "type": "uint8"
            }
        ],
        "name": "ChangeSttWl",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "stt",
                "type": "uint256"
            }
        ],
        "name": "EndSale",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amountToken",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amountBNB",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "liquidity",
                "type": "uint256"
            }
        ],
        "name": "LiquidityAddedWithBNBAndToken",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amountToken",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amountUSDT",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "liquidity",
                "type": "uint256"
            }
        ],
        "name": "LiquidityAddedWithUSDTAndToken",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "liquidityLockDuration",
                "type": "uint256"
            }
        ],
        "name": "LiquidityLocked",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "buyer",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "TokensClaimed",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "buyer",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "TokensPurchased",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "TokensReceived",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "buyer",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "UnContribute",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "timePublic",
                "type": "uint256"
            }
        ],
        "name": "UpdateTimePublic",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "_historyRef",
        "outputs": [
            {
                "internalType": "address",
                "name": "userAdd",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "ref",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "addFeeUnCon",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "addressesToAdd",
                "type": "address[]"
            }
        ],
        "name": "addToWhitelist",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "contract IERC20",
                "name": "tokenss",
                "type": "address"
            }
        ],
        "name": "adminCancel",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "balances",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "cancel",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "logoUrl",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "website",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "facebook",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "twitter",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "github",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "telegram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "instagram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "reddit",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "discord",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "youtube",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "description",
                        "type": "string"
                    }
                ],
                "internalType": "struct Launchpad.LaunchpadParamsStep3",
                "name": "params3",
                "type": "tuple"
            }
        ],
        "name": "changeInfoSocialNetwork",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "wlstt",
                "type": "uint8"
            }
        ],
        "name": "changeSttWhiteList",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "checkAndUpdateSale",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "claimTokens",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "claimed",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "claimedCommission",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "commission",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "tokenAdd",
                "type": "address"
            }
        ],
        "name": "contribute",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "tokenAdd",
                "type": "address"
            }
        ],
        "name": "contributeWithToken",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "creationFeeOptionBnb",
        "outputs": [
            {
                "internalType": "uint8",
                "name": "",
                "type": "uint8"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "creationFeeOptionBnbToken",
        "outputs": [
            {
                "internalType": "uint8",
                "name": "",
                "type": "uint8"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "deverAddress",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "getWhitelist",
        "outputs": [
            {
                "internalType": "address[]",
                "name": "",
                "type": "address[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "isOwner",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "isSaleActive",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "launchpadParamsStep1",
        "outputs": [
            {
                "internalType": "address",
                "name": "currency",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "feeOption",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "listingOption",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "affiliate",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "totalTokenTo",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "decimals",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "contractToken",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "launchpadParamsStep2",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "preRate",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "whiteList",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "liquidityLockDay",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "router",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "softCap",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "hardCap",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "minBuy",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "maxBuy",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "typeRefund",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "liquidityRate",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "listingRate",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "startTime",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "endTime",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "BDFSALE_LOCKER_ADDRESS",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "launchpadParamsStep3",
        "outputs": [
            {
                "internalType": "string",
                "name": "logoUrl",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "website",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "facebook",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "twitter",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "github",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "telegram",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "instagram",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "reddit",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "discord",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "youtube",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "description",
                "type": "string"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "listUsersRef",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "ref",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address[]",
                "name": "addressesToRemove",
                "type": "address[]"
            }
        ],
        "name": "removeFromWhitelist",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "timePublicWls",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "token",
        "outputs": [
            {
                "internalType": "contract IERC20",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "tokenPayment",
        "outputs": [
            {
                "internalType": "contract IERC20",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalBuyed",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalCommission",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalContributors",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalHistoryRefs",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalWhitelist",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "unContribute",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint8",
                "name": "num",
                "type": "uint8"
            }
        ],
        "name": "updateAffiliate",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "timePublic",
                "type": "uint256"
            }
        ],
        "name": "updateTimePublic",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "whitelist",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "whitelistAddresses",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "withdrawAllCommission",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "withdrawFunds",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "stateMutability": "payable",
        "type": "receive"
    }
]

const abi_childStake = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "joinToken",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "_timeCanUnlock",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_percentWithdraw",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_percentCommissionF1",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_minStake",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_maxStake",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_percentProfit",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_maxOut",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_pool",
                "type": "uint256"
            },
            {
                "internalType": "uint8",
                "name": "percentDepositDis_",
                "type": "uint8"
            },
            {
                "internalType": "address",
                "name": "serviceFeeReceiver__",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "receiveAddress_",
                "type": "address"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "_joinToken",
        "outputs": [
            {
                "internalType": "contract IERC20Mintable",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "_stake",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "userAddress",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "timestamp",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "received",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "commission",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "pt",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "maxOut",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "ref",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "timeCanUnlock",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "percentWithdraw",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_timeCanUnlock",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_percentWithdraw",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_percentCommissionF1",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_minStake",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_maxStake",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_percentProfit",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_maxOut",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "_receiveAddress",
                "type": "address"
            }
        ],
        "name": "editDefi",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "maxOut",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "maxStake",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "minStake",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "percentCommissionF1",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "percentProfit",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "percentWithdraw",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "pool",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "receiveAddress",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "amountIp",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "ref",
                "type": "address"
            }
        ],
        "name": "staking",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "timeCanUnlock",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalPackage",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "unStaking",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "withdraw",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
    }
]

const contractListLaunch = "0x1F17025B91676702b987aCFb58809Ca8A2917bA4";
const abi_listlaunch = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "launchpadAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "currency",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "feeOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "affiliate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "totalTokenTo",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "decimals",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "contractToken",
                        "type": "address"
                    }
                ],
                "internalType": "struct LaunchpadManager.LaunchpadParamsStep1",
                "name": "params1",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "preRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "whiteList",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityLockDay",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "router",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "softCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "hardCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "maxBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "typeRefund",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "startTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "endTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "BDFSALE_LOCKER_ADDRESS",
                        "type": "address"
                    }
                ],
                "internalType": "struct LaunchpadManager.LaunchpadParamsStep2",
                "name": "params2",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "logoUrl",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "website",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "facebook",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "twitter",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "github",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "telegram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "instagram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "reddit",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "discord",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "youtube",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "description",
                        "type": "string"
                    }
                ],
                "internalType": "struct LaunchpadManager.LaunchpadParamsStep3",
                "name": "params3",
                "type": "tuple"
            }
        ],
        "name": "addLaunchpad",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "minter",
                "type": "address"
            }
        ],
        "name": "addMinter",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "minter",
                "type": "address"
            }
        ],
        "name": "removeMinter",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "launchpadAddress",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "name",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "symbol",
                        "type": "string"
                    },
                    {
                        "internalType": "uint8",
                        "name": "decimals",
                        "type": "uint8"
                    }
                ],
                "indexed": false,
                "internalType": "struct LaunchpadManager.TokenInfoData",
                "name": "tokenInfo",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "currency",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "feeOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingOption",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "affiliate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "totalTokenTo",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "decimals",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "contractToken",
                        "type": "address"
                    }
                ],
                "indexed": false,
                "internalType": "struct LaunchpadManager.LaunchpadParamsStep1",
                "name": "params1",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "uint256",
                        "name": "preRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "whiteList",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityLockDay",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "router",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "softCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "hardCap",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "minBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "maxBuy",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "typeRefund",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "liquidityRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "listingRate",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "startTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "endTime",
                        "type": "uint256"
                    },
                    {
                        "internalType": "address",
                        "name": "BDFSALE_LOCKER_ADDRESS",
                        "type": "address"
                    }
                ],
                "indexed": false,
                "internalType": "struct LaunchpadManager.LaunchpadParamsStep2",
                "name": "params2",
                "type": "tuple"
            },
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "logoUrl",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "website",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "facebook",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "twitter",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "github",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "telegram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "instagram",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "reddit",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "discord",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "youtube",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "description",
                        "type": "string"
                    }
                ],
                "indexed": false,
                "internalType": "struct LaunchpadManager.LaunchpadParamsStep3",
                "name": "params3",
                "type": "tuple"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "time",
                "type": "uint256"
            }
        ],
        "name": "LaunchpadCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "_launchpads",
        "outputs": [
            {
                "internalType": "address",
                "name": "launchpadAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            }
        ],
        "name": "getLaunchpadsByOwner",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "launchpadAddress",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    }
                ],
                "internalType": "struct LaunchpadManager.Launchpad[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "start",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "end",
                "type": "uint256"
            }
        ],
        "name": "getLaunchpadsInRange",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "launchpadAddress",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    }
                ],
                "internalType": "struct LaunchpadManager.Launchpad[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "getTokenInfo",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "name",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "symbol",
                        "type": "string"
                    },
                    {
                        "internalType": "uint8",
                        "name": "decimals",
                        "type": "uint8"
                    }
                ],
                "internalType": "struct LaunchpadManager.TokenInfoData",
                "name": "",
                "type": "tuple"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "minters",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalLaunchpads",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const abi_tokenDefault = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "sender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount0", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount1", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }], "name": "Burn", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "sender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount0", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount1", "type": "uint256" }], "name": "Mint", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "sender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount0In", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount1In", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount0Out", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "amount1Out", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }], "name": "Swap", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint112", "name": "reserve0", "type": "uint112" }, { "indexed": false, "internalType": "uint112", "name": "reserve1", "type": "uint112" }], "name": "Sync", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "DOMAIN_SEPARATOR", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "MINIMUM_LIQUIDITY", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "PERMIT_TYPEHASH", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "address", "name": "", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "to", "type": "address" }], "name": "burn", "outputs": [{ "internalType": "uint256", "name": "amount0", "type": "uint256" }, { "internalType": "uint256", "name": "amount1", "type": "uint256" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "factory", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "getReserves", "outputs": [{ "internalType": "uint112", "name": "_reserve0", "type": "uint112" }, { "internalType": "uint112", "name": "_reserve1", "type": "uint112" }, { "internalType": "uint32", "name": "_blockTimestampLast", "type": "uint32" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "_token0", "type": "address" }, { "internalType": "address", "name": "_token1", "type": "address" }], "name": "initialize", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "kLast", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "to", "type": "address" }], "name": "mint", "outputs": [{ "internalType": "uint256", "name": "liquidity", "type": "uint256" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "nonces", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }, { "internalType": "uint256", "name": "deadline", "type": "uint256" }, { "internalType": "uint8", "name": "v", "type": "uint8" }, { "internalType": "bytes32", "name": "r", "type": "bytes32" }, { "internalType": "bytes32", "name": "s", "type": "bytes32" }], "name": "permit", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "price0CumulativeLast", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "price1CumulativeLast", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "to", "type": "address" }], "name": "skim", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount0Out", "type": "uint256" }, { "internalType": "uint256", "name": "amount1Out", "type": "uint256" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "bytes", "name": "data", "type": "bytes" }], "name": "swap", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "sync", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "token0", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "token1", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "from", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }, { "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }]

const contractLock = '0xA4d68833853FDf3471df0779A356726ae56A3025';
const abi_lock = [{ "anonymous": false, "inputs": [{ "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" }, { "indexed": false, "internalType": "address", "name": "token", "type": "address" }, { "indexed": false, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "unlockDate", "type": "uint256" }], "name": "LockAdded", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "lockId", "type": "uint256" }], "name": "LockDescriptionChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "lockId", "type": "uint256" }, { "indexed": false, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": false, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "LockOwnerChanged", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" }, { "indexed": false, "internalType": "address", "name": "token", "type": "address" }, { "indexed": false, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "unlockedAt", "type": "uint256" }], "name": "LockRemoved", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" }, { "indexed": false, "internalType": "address", "name": "token", "type": "address" }, { "indexed": false, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "newAmount", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "newUnlockDate", "type": "uint256" }], "name": "LockUpdated", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "uint256", "name": "id", "type": "uint256" }, { "indexed": false, "internalType": "address", "name": "token", "type": "address" }, { "indexed": false, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "remaining", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "timestamp", "type": "uint256" }], "name": "LockVested", "type": "event" }, { "inputs": [], "name": "allLpTokenLockedCount", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "allNormalTokenLockedCount", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "cumulativeLockInfo", "outputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "factory", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "lockId", "type": "uint256" }, { "internalType": "uint256", "name": "newAmount", "type": "uint256" }, { "internalType": "uint256", "name": "newUnlockDate", "type": "uint256" }], "name": "editLock", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "lockId", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "name": "editLockDescription", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "start", "type": "uint256" }, { "internalType": "uint256", "name": "end", "type": "uint256" }], "name": "getCumulativeLpTokenLockInfo", "outputs": [{ "components": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "factory", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "internalType": "struct BDFLock02.CumulativeLockInfo[]", "name": "", "type": "tuple[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "index", "type": "uint256" }], "name": "getCumulativeLpTokenLockInfoAt", "outputs": [{ "components": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "factory", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "internalType": "struct BDFLock02.CumulativeLockInfo", "name": "", "type": "tuple" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "start", "type": "uint256" }, { "internalType": "uint256", "name": "end", "type": "uint256" }], "name": "getCumulativeNormalTokenLockInfo", "outputs": [{ "components": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "factory", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "internalType": "struct BDFLock02.CumulativeLockInfo[]", "name": "", "type": "tuple[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "index", "type": "uint256" }], "name": "getCumulativeNormalTokenLockInfoAt", "outputs": [{ "components": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "factory", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "internalType": "struct BDFLock02.CumulativeLockInfo", "name": "", "type": "tuple" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "index", "type": "uint256" }], "name": "getLockAt", "outputs": [{ "components": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "lockDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeBps", "type": "uint256" }, { "internalType": "uint256", "name": "cycle", "type": "uint256" }, { "internalType": "uint256", "name": "cycleBps", "type": "uint256" }, { "internalType": "uint256", "name": "unlockedAmount", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "internalType": "struct BDFLock02.Lock", "name": "", "type": "tuple" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "lockId", "type": "uint256" }], "name": "getLockById", "outputs": [{ "components": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "lockDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeBps", "type": "uint256" }, { "internalType": "uint256", "name": "cycle", "type": "uint256" }, { "internalType": "uint256", "name": "cycleBps", "type": "uint256" }, { "internalType": "uint256", "name": "unlockedAmount", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "internalType": "struct BDFLock02.Lock", "name": "", "type": "tuple" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "uint256", "name": "start", "type": "uint256" }, { "internalType": "uint256", "name": "end", "type": "uint256" }], "name": "getLocksForToken", "outputs": [{ "components": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "lockDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeBps", "type": "uint256" }, { "internalType": "uint256", "name": "cycle", "type": "uint256" }, { "internalType": "uint256", "name": "cycleBps", "type": "uint256" }, { "internalType": "uint256", "name": "unlockedAmount", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "internalType": "struct BDFLock02.Lock[]", "name": "", "type": "tuple[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "getTotalLockCount", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "bool", "name": "isLpToken", "type": "bool" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "unlockDate", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "name": "lock", "outputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }], "name": "lpLockCountForUser", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }, { "internalType": "uint256", "name": "index", "type": "uint256" }], "name": "lpLockForUserAtIndex", "outputs": [{ "components": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "lockDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeBps", "type": "uint256" }, { "internalType": "uint256", "name": "cycle", "type": "uint256" }, { "internalType": "uint256", "name": "cycleBps", "type": "uint256" }, { "internalType": "uint256", "name": "unlockedAmount", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "internalType": "struct BDFLock02.Lock", "name": "", "type": "tuple" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }], "name": "lpLocksForUser", "outputs": [{ "components": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "lockDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeBps", "type": "uint256" }, { "internalType": "uint256", "name": "cycle", "type": "uint256" }, { "internalType": "uint256", "name": "cycleBps", "type": "uint256" }, { "internalType": "uint256", "name": "unlockedAmount", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "internalType": "struct BDFLock02.Lock[]", "name": "", "type": "tuple[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address[]", "name": "owners", "type": "address[]" }, { "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "bool", "name": "isLpToken", "type": "bool" }, { "internalType": "uint256", "name": "tgeDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeBps", "type": "uint256" }, { "internalType": "uint256", "name": "cycle", "type": "uint256" }, { "internalType": "uint256", "name": "cycleBps", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "name": "multipleVestingLock", "outputs": [{ "internalType": "uint256[]", "name": "", "type": "uint256[]" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }], "name": "normalLockCountForUser", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }, { "internalType": "uint256", "name": "index", "type": "uint256" }], "name": "normalLockForUserAtIndex", "outputs": [{ "components": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "lockDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeBps", "type": "uint256" }, { "internalType": "uint256", "name": "cycle", "type": "uint256" }, { "internalType": "uint256", "name": "cycleBps", "type": "uint256" }, { "internalType": "uint256", "name": "unlockedAmount", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "internalType": "struct BDFLock02.Lock", "name": "", "type": "tuple" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }], "name": "normalLocksForUser", "outputs": [{ "components": [{ "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "lockDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeBps", "type": "uint256" }, { "internalType": "uint256", "name": "cycle", "type": "uint256" }, { "internalType": "uint256", "name": "cycleBps", "type": "uint256" }, { "internalType": "uint256", "name": "unlockedAmount", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "internalType": "struct BDFLock02.Lock[]", "name": "", "type": "tuple[]" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "lockId", "type": "uint256" }], "name": "renounceLockOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }], "name": "totalLockCountForToken", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "user", "type": "address" }], "name": "totalLockCountForUser", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalTokenLockedCount", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "lockId", "type": "uint256" }, { "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferLockOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "lockId", "type": "uint256" }], "name": "unlock", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "token", "type": "address" }, { "internalType": "bool", "name": "isLpToken", "type": "bool" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "tgeDate", "type": "uint256" }, { "internalType": "uint256", "name": "tgeBps", "type": "uint256" }, { "internalType": "uint256", "name": "cycle", "type": "uint256" }, { "internalType": "uint256", "name": "cycleBps", "type": "uint256" }, { "internalType": "string", "name": "description", "type": "string" }], "name": "vestingLock", "outputs": [{ "internalType": "uint256", "name": "id", "type": "uint256" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "lockId", "type": "uint256" }], "name": "withdrawableTokens", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }]

const contractCreateStandardToken = "0x8e3b6971E0AfEb70C7BA468A50A8f605bD58c430";
const abi_createStandardToken = [
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "name_",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "symbol_",
                "type": "string"
            },
            {
                "internalType": "uint8",
                "name": "decimals_",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "totalSupply_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "pinkAntiBot_",
                "type": "address"
            }
        ],
        "name": "createAntiBotStandardToken",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "name_",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "symbol_",
                "type": "string"
            },
            {
                "internalType": "uint8",
                "name": "decimals_",
                "type": "uint8"
            },
            {
                "internalType": "uint256",
                "name": "totalSupply_",
                "type": "uint256"
            }
        ],
        "name": "createStandardToken",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_serviceFee_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "_serviceFeeReceiver_",
                "type": "address"
            }
        ],
        "name": "editFee",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "version",
                "type": "uint256"
            }
        ],
        "name": "TokenCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractCreateLiquidityGeneratorToken = "0xc3ADFe46F21aE126d29dFD5dC8643F278718afAf";
const abi_createLiquidityGeneratorToken = [
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "name_",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "symbol_",
                "type": "string"
            },
            {
                "internalType": "uint256",
                "name": "totalSupply_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "router_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "charityAddress_",
                "type": "address"
            },
            {
                "internalType": "uint16",
                "name": "taxFeeBps_",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "liquidityFeeBps_",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "charityFeeBps_",
                "type": "uint16"
            }
        ],
        "name": "createToken",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_serviceFee_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "_serviceFeeReceiver_",
                "type": "address"
            }
        ],
        "name": "editFee",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "version",
                "type": "uint256"
            }
        ],
        "name": "TokenCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractCreateAntiBotLiquidityGeneratorToken = "0xf80F22Be07A50116e5bB0555A8F58B347f66226d";
const abi_createAntiBotLiquidityGeneratorToken = [
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "name_",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "symbol_",
                "type": "string"
            },
            {
                "internalType": "uint256",
                "name": "totalSupply_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "router_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "charityAddress_",
                "type": "address"
            },
            {
                "internalType": "uint16",
                "name": "taxFeeBps_",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "liquidityFeeBps_",
                "type": "uint16"
            },
            {
                "internalType": "uint16",
                "name": "charityFeeBps_",
                "type": "uint16"
            },
            {
                "internalType": "address",
                "name": "pinkAntiBot_",
                "type": "address"
            }
        ],
        "name": "createToken",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_serviceFee_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "_serviceFeeReceiver_",
                "type": "address"
            }
        ],
        "name": "editFee",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "version",
                "type": "uint256"
            }
        ],
        "name": "TokenCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractCreateBABYTOKEN = "0x6b4bB628FBf1cf1DA3Fba9faDC63B7aC6B6BbB0f";
const abi_createBABYTOKEN = [
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "name_",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "symbol_",
                "type": "string"
            },
            {
                "internalType": "uint256",
                "name": "totalSupply_",
                "type": "uint256"
            },
            {
                "internalType": "address[4]",
                "name": "addrs",
                "type": "address[4]"
            },
            {
                "internalType": "uint256[3]",
                "name": "feeSettings",
                "type": "uint256[3]"
            },
            {
                "internalType": "uint256",
                "name": "minimumTokenBalanceForDividends_",
                "type": "uint256"
            }
        ],
        "name": "createToken",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_serviceFee_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "_serviceFeeReceiver_",
                "type": "address"
            }
        ],
        "name": "editFee",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "version",
                "type": "uint256"
            }
        ],
        "name": "TokenCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractCreateAntiBotBABYTOKEN = "0x19dB0F2f47fB674A34a176d4168e5cACa152e510";
const abi_createAntiBotBABYTOKEN = [
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "name_",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "symbol_",
                "type": "string"
            },
            {
                "internalType": "uint256",
                "name": "totalSupply_",
                "type": "uint256"
            },
            {
                "internalType": "address[5]",
                "name": "addrs",
                "type": "address[5]"
            },
            {
                "internalType": "uint256[3]",
                "name": "feeSettings",
                "type": "uint256[3]"
            },
            {
                "internalType": "uint256",
                "name": "minimumTokenBalanceForDividends_",
                "type": "uint256"
            }
        ],
        "name": "createToken",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_serviceFee_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "_serviceFeeReceiver_",
                "type": "address"
            }
        ],
        "name": "editFee",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "version",
                "type": "uint256"
            }
        ],
        "name": "TokenCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractCreateBuybackBabyToken = "0x99F4E2f62d93F73175cEa2B770252507450561cB";
const abi_createBuybackBabyToken = [
    {
        "inputs": [
            {
                "internalType": "string",
                "name": "name_",
                "type": "string"
            },
            {
                "internalType": "string",
                "name": "symbol_",
                "type": "string"
            },
            {
                "internalType": "uint256",
                "name": "totalSupply_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "rewardToken_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "router_",
                "type": "address"
            },
            {
                "internalType": "uint256[5]",
                "name": "feeSettings_",
                "type": "uint256[5]"
            }
        ],
        "name": "createToken",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_serviceFee_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "_serviceFeeReceiver_",
                "type": "address"
            }
        ],
        "name": "editFee",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "token",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "version",
                "type": "uint256"
            }
        ],
        "name": "TokenCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractSender = "0xb5b9f9fe8A416565ADaC1d6DcA4B3a85775e701f";
const abi_sender = [{ "anonymous": false, "inputs": [{ "indexed": false, "internalType": "address", "name": "token", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "total", "type": "uint256" }], "name": "Multisent", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "inputs": [{ "internalType": "address[]", "name": "targets", "type": "address[]" }, { "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "name": "multisendEther", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "bool", "name": "ensureExactAmount", "type": "bool" }, { "internalType": "address[]", "name": "targets", "type": "address[]" }, { "internalType": "uint256[]", "name": "amounts", "type": "uint256[]" }], "name": "multisendToken", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "to", "type": "address" }], "name": "withdrawWronglySentEther", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "token", "type": "address" }, { "internalType": "address", "name": "to", "type": "address" }], "name": "withdrawWronglySentToken", "outputs": [], "stateMutability": "nonpayable", "type": "function" }]

const contractCreateBankStaking = "0x33B21244993539AD554aAEb10428503B3780Be9b";
const abi_bankstaking = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAdd",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "_timeCanUnlock",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_percentWithdraw",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_percentCommissionF1",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_minStake",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_maxStake",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_percentProfit",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_maxOut",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "_pool",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "receiveAddress",
                "type": "address"
            }
        ],
        "name": "createStaking",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "_serviceFee_",
                "type": "uint256"
            },
            {
                "internalType": "address",
                "name": "_serviceFeeReceiver_",
                "type": "address"
            },
            {
                "internalType": "uint8",
                "name": "percentDepositDis_",
                "type": "uint8"
            }
        ],
        "name": "editFee",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
    },
    {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "token",
                "type": "address"
            }
        ],
        "name": "TokenCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractListStake = "0x72f6c6e11283DE39812F700D4e3c71A6d4E7BB32";
const abi_liststake = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "minter",
                "type": "address"
            }
        ],
        "name": "addMinter",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "stakeAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "addStake",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "minter",
                "type": "address"
            }
        ],
        "name": "removeMinter",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "stakeAddress",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            },
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "name",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "symbol",
                        "type": "string"
                    },
                    {
                        "internalType": "uint8",
                        "name": "decimals",
                        "type": "uint8"
                    }
                ],
                "indexed": false,
                "internalType": "struct StakeManager.TokenInfoData",
                "name": "tokenInfo",
                "type": "tuple"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "time",
                "type": "uint256"
            }
        ],
        "name": "StakeCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "_stake",
        "outputs": [
            {
                "internalType": "address",
                "name": "stakeAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            }
        ],
        "name": "getStakesByOwner",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "stakeAddress",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "tokenAddress",
                        "type": "address"
                    }
                ],
                "internalType": "struct StakeManager.Stake[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "start",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "end",
                "type": "uint256"
            }
        ],
        "name": "getStakesInRange",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "stakeAddress",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "tokenAddress",
                        "type": "address"
                    }
                ],
                "internalType": "struct StakeManager.Stake[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "getTokenInfo",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "name",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "symbol",
                        "type": "string"
                    },
                    {
                        "internalType": "uint8",
                        "name": "decimals",
                        "type": "uint8"
                    }
                ],
                "internalType": "struct StakeManager.TokenInfoData",
                "name": "",
                "type": "tuple"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "minters",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalStake",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractListBuy = "0x42570674f62767De7b4dD2acD732bAC11AeBac0E";
const abi_listbuy = [
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "launchAddress",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "time",
                "type": "uint256"
            }
        ],
        "name": "BuyCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "_buy",
        "outputs": [
            {
                "internalType": "address",
                "name": "launchpadAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "launchpadAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "addBuy",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            }
        ],
        "name": "getBuysByOwner",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "launchpadAddress",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct BuyManager.Buy[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "start",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "end",
                "type": "uint256"
            }
        ],
        "name": "getBuysInRange",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "launchpadAddress",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct BuyManager.Buy[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "tokenAddress",
                "type": "address"
            }
        ],
        "name": "getTokenInfo",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "string",
                        "name": "name",
                        "type": "string"
                    },
                    {
                        "internalType": "string",
                        "name": "symbol",
                        "type": "string"
                    },
                    {
                        "internalType": "uint8",
                        "name": "decimals",
                        "type": "uint8"
                    }
                ],
                "internalType": "struct BuyManager.TokenInfoData",
                "name": "",
                "type": "tuple"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "name": "minters",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "owner",
        "outputs": [
            {
                "internalType": "address",
                "name": "",
                "type": "address"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalBuy",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

const contractListDepositStake = "0x0eb24BF85C57B3d6d2Cb5eDECf8F1b284c871894";
const abi_listdepositstake = [
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "stakeAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "addBuy",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "inputs": [],
        "stateMutability": "nonpayable",
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": false,
                "internalType": "address",
                "name": "launchAddress",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            },
            {
                "indexed": false,
                "internalType": "uint256",
                "name": "time",
                "type": "uint256"
            }
        ],
        "name": "BuyCreated",
        "type": "event"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "name": "_buy",
        "outputs": [
            {
                "internalType": "address",
                "name": "stakeAddress",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            },
            {
                "internalType": "uint256",
                "name": "amount",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "address",
                "name": "owner_",
                "type": "address"
            }
        ],
        "name": "getBuysByOwner",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "stakeAddress",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct BuyManager.Buy[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [
            {
                "internalType": "uint256",
                "name": "start",
                "type": "uint256"
            },
            {
                "internalType": "uint256",
                "name": "end",
                "type": "uint256"
            }
        ],
        "name": "getBuysInRange",
        "outputs": [
            {
                "components": [
                    {
                        "internalType": "address",
                        "name": "stakeAddress",
                        "type": "address"
                    },
                    {
                        "internalType": "address",
                        "name": "owner_",
                        "type": "address"
                    },
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "internalType": "struct BuyManager.Buy[]",
                "name": "",
                "type": "tuple[]"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    },
    {
        "inputs": [],
        "name": "totalBuy",
        "outputs": [
            {
                "internalType": "uint256",
                "name": "",
                "type": "uint256"
            }
        ],
        "stateMutability": "view",
        "type": "function"
    }
]

export {
    web3Prov, domain, bigUnit, feeDenominator, addresAntibot, addresBABYTOKENDividendTracker, contractUsdt, abi_usdt, contractStaking,
    abi_staking, contractTokenInfo, abi_tokenInfo, contractLaunchpad, abi_launchpad, contractFairlaunch, abi_fairlaunch,
    abi_childLaunchpad, abi_childStake, contractListLaunch, abi_listlaunch, abi_tokenDefault, contractLock, abi_lock,
    contractCreateStandardToken, abi_createStandardToken, contractCreateLiquidityGeneratorToken, abi_createLiquidityGeneratorToken,
    contractCreateAntiBotLiquidityGeneratorToken, abi_createAntiBotLiquidityGeneratorToken, contractCreateBABYTOKEN, abi_createBABYTOKEN,
    contractCreateAntiBotBABYTOKEN, abi_createAntiBotBABYTOKEN, contractCreateBuybackBabyToken, abi_createBuybackBabyToken,
    contractSender, abi_sender, contractCreateBankStaking, abi_bankstaking, contractListStake, abi_liststake, contractListBuy,
    abi_listbuy, contractListDepositStake, abi_listdepositstake
};
// module.exports = { contractTokenInfo, abi_tokenInfo };